// Lib
import React from 'react';

// Components
import Badge from '../misc/Badge';

// Styles
import './ProBadge.scss';

const ProBadge = () => <Badge className="ProBadge">Pro</Badge>;

export default ProBadge;
